import { format } from 'date-fns';
import { DEFAULT_OPTIONS, GRID_LINE_COLOR, LABEL_STYLE, PAGE_BG_COLOR, DEFAULT_TEXT_STYLE, TIMECHART_COLORS, DATE_FORMAT, } from '../../../constants/chart';
export const getTimeseriesChartOptions = (timeChartData, scrollable = false, height, width, customOptions) => (Object.assign(Object.assign({}, DEFAULT_OPTIONS), { title: Object.assign({}, customOptions === null || customOptions === void 0 ? void 0 : customOptions.title), chart: Object.assign(Object.assign(Object.assign({}, DEFAULT_OPTIONS.chart), { height,
        width, scrollablePlotArea: scrollable
            ? {
                minWidth: 300,
            }
            : undefined }), customOptions === null || customOptions === void 0 ? void 0 : customOptions.chart), tooltip: Object.assign({ backgroundColor: PAGE_BG_COLOR, style: DEFAULT_TEXT_STYLE, formatter() {
            return `${format(this.point.x, DATE_FORMAT)}<br />Value: ${this.point.y}`;
        } }, customOptions === null || customOptions === void 0 ? void 0 : customOptions.tooltip), xAxis: Object.assign({ type: 'datetime', labels: {
            style: LABEL_STYLE,
        } }, customOptions === null || customOptions === void 0 ? void 0 : customOptions.xAxis), colors: (customOptions === null || customOptions === void 0 ? void 0 : customOptions.colors) || TIMECHART_COLORS, yAxis: Object.assign({ title: {
            text: 'Value',
            style: LABEL_STYLE,
        }, gridLineColor: GRID_LINE_COLOR, gridLineWidth: 1, labels: {
            style: LABEL_STYLE,
        } }, customOptions === null || customOptions === void 0 ? void 0 : customOptions.yAxis), legend: Object.assign({ enabled: true, itemStyle: Object.assign(Object.assign({}, LABEL_STYLE), { fontWeight: 'normal' }), itemHoverStyle: Object.assign(Object.assign({}, LABEL_STYLE), { fontWeight: 'normal' }), rtl: true }, customOptions === null || customOptions === void 0 ? void 0 : customOptions.legend), plotOptions: {
        spline: {
            marker: {
                radius: 2,
            },
            lineWidth: 2,
            states: {
                hover: {
                    lineWidth: 1,
                },
            },
        },
    }, series: timeChartData.map((data) => (Object.assign({ type: 'spline' }, data))) }));
//# sourceMappingURL=index.js.map